var map = {
	"./Academic.svg": 5012,
	"./Elections.svg": 9691,
	"./Enrolment.svg": 2415,
	"./Examination.svg": 4480,
	"./Graduation.svg": 2257,
	"./Revision.svg": 4018,
	"./Teaching.svg": 2772,
	"./Vacation.svg": 8596
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3159;